import {XANADU} from '../transactions/contracts.js';
import XanaduContract from '../contracts/XanaduContract.js';
import BackendQuery from 'decentralized/BackendQuery.js';
import EthereumQuery from 'decentralized/EthereumQuery.js';
import {ipfsHashToBytes32} from 'utils/ipfsHash.js';
import EthereumTransaction from '../transactions/EthereumTransaction.js';
import {SOUND_RATED} from './LinkTypes.js';
import {PRESET_RATED} from './LinkTypes.js';
import {
    NewAnnotationType,
    NewAnnotation,
    NewLinkType,
    NewLink,
    NewDataType
} from 'decentralized/EthereumEvents.js';

let cache = {};
export default superclass => class extends superclass  {
    async rateSound(hash, rating, type=SOUND_RATED) {
        await new EthereumTransaction(
            XANADU,
            'newAnnotation',
            [
                this.web3.utils.fromAscii(type),
                ipfsHashToBytes32(hash),
                this.web3.utils.fromAscii(rating.toString())])
            .execute();
    }

    async getSoundsWithRating(hashes, ratingToFilter, user) {
        let query = new BackendQuery(new XanaduContract().contractAddress)
            .from(NewAnnotation)
            .select('data')
            .select('annotationData')
            .whereIn('data', hashes);
        if (user) {
            query.where("address", user.toLowerCase());
        }

        let results = await query.executeQuery();
        let idToRating = {};
        for (let result of results) {
            let id = result.data;
            let rating = parseInt(result.annotationData);
            if (idToRating[id] === undefined && rating===ratingToFilter) {
                idToRating[id] = rating;
            }
        }
        return Object.keys(idToRating);
    }

    async getSoundRating(hash, type=SOUND_RATED, user) {
        let key = type + '.' + hash;
        if (user) {
            key += " " + user;
        }
        if (key in cache) {
            return cache[key];
        }
        let query = new BackendQuery(new XanaduContract().contractAddress)
            .from(NewAnnotation)
            .select('data')
            .select('annotationData')
            .where('data', hash);
            //.where('annotationType', type);

        if (user) {
            query.where("address", user.toLowerCase());
        }

        let results = await query.executeQuery();
        if (results.length === 0) {
            cache[key] = undefined;
            return undefined;
        }
        cache[key] = parseInt(results[0].annotationData);
        return cache[key];
    }
}
